<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-actions>
              <v-btn
                class="mr-1"
                color="secondary"
                to="/admin/playlists"
                outlined
              >
                <v-icon small class="mr-1">fa-chevron-left</v-icon>Back
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="mr-1"
                color="primary"
                @click.prevent="addLevel"
                outlined
              >
                <v-icon small class="mr-1">fa-plus</v-icon>Add Level
              </v-btn>
              <v-btn
                class="mr-1"
                color="primary"
                @click.prevent="saveChannel"
                outlined
              >
                <v-icon small class="mr-1">fa-save</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="pageLoading">
        <v-col md="12">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col md="12">
          <kanban-board
            :stages="stages"
            :blocks="blocks"
            @update-block="updateBlock"
          >
            <div v-for="stage in stages" :slot="stage" :key="stage">
              <v-toolbar color="secondary" flat>
                <v-toolbar-title class="white--text">
                  <v-icon class="icon white--text">fa-list</v-icon>
                  {{ stage }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon
                  v-if="stage != 'Unassigned Modules'"
                  @click="removeLevel(stage)"
                  >fa-times</v-icon
                >
              </v-toolbar>
            </div>
            <div v-for="block in blocks" :slot="block.id" :key="block.id">
              <v-card>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ block.title }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-avatar tile size="80">
                    <img :src="transfrom(block.thumb)" />
                  </v-list-item-avatar>
                </v-list-item>
              </v-card>
            </div>
          </kanban-board>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import channelAPI from '@/api/channel.js';
import LayoutBasic from '@/layouts/Dashboard';
import Modules from '@/components/admin/channels/Modules';
import { IMPROVE_CONFIG } from '@/config.js';
import thumbSizes from '@/utils/thumbs.js';

export default {
  name: 'OrganiseChannels',
  components: {
    LayoutBasic,
    Modules,
  },
  data() {
    return {
      id: this.$route.params.id,
      channel: [],
      levels: 0,
      availableChannels: [],
      successMessage: 'Channel Updated',
      errorMessage: 'Oops! something went wrong.',
      pageLoading: true,
    };
  },
  computed: {
    stages() {
      let stages = ['Unassigned Modules'];
      for (var i = 0; i < this.levels; i++) {
        stages.push('Level ' + (i + 1));
      }
      return stages;
    },
    courses() {
      return this.channel.kanban ? this.channel.kanban.data : [];
    },
    blocks() {
      let blocks = this.courses.map(function (x) {
        return {
          id: x.id,
          status: x.status,
          title: x.name,
          sort: x.sort_order,
          thumb: x.file ? x.file.key : null,
        };
      });

      return blocks;
    },
  },
  mounted() {
    this.getChannel();
  },
  methods: {
    addLevel() {
      this.levels++;
    },
    removeLevel(stage) {
      this.courses
        .filter(function (item) {
          return item.status == stage;
        })
        .forEach((item) => (item.status = 'Unassigned Modules'));

      this.levels--;
    },
    transfrom(key) {
      const imageRequest = JSON.stringify({
        bucket: `${IMPROVE_CONFIG.BUCKET}`,
        key: key,
        edits: thumbSizes.medium,
      });
      return `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(imageRequest)}`;
    },
    saveChannel() {
      this.loading = true;
      channelAPI
        .saveKanban(this.id, this.blocks, this.stages)
        .then(() => {
          this.$router.push('/admin/playlists');
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.success(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    updateBlock(id, status, x, y) {
      this.blocks.find((b) => b.id === String(id)).status = status;
    },
    getChannel() {
      this.loading = true;
      channelAPI.getChannel(this.id, '?include=courses,kanban').then((resp) => {
        this.channel = resp.data.data;
        this.levels = this.channel.levels;
        this.pageLoading = false;
      });
    },
    showModulesPanel() {
      this.$showPanel({
        component: Modules,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
